import { useQuery } from 'react-query'
import { ratingScores } from 'services/api'
import { isCallAllowed } from 'configs'
import { LocalId } from 'globalTypes'

export function useRatingScores(localId: LocalId, staleTime = 0) {
  return useQuery(
    ['ratingScores', localId.id, localId.country],
    () => ratingScores(localId),
    {
      staleTime,
      enabled: !!isCallAllowed('ratingScores', localId.country),
      retry: false,
      refetchOnWindowFocus: false,
    },
  )
}
